import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable()
export class CartoService {
  constructor(private http: HttpClient) {}

  protected queryData(
    sql: string,
    params: any = undefined,
    headerParams: Record<string, string> = {}
  ) {
    const query = encodeURIComponent(sql);
    const queryParams = params;
    let url = `${environment.carto.baseUrl}/${environment.carto.connection}/query?q=${query}`;
    if (queryParams) {
      url += `&queryParameters=${queryParams}`;
    }
    const bearer = `Bearer ${environment.carto.public_access_token}`;
    return (
      this.http
        .get(url, { headers: { Authorization: bearer, ...headerParams } })
        // .map((json: any) => {
        //   if (json && json.rows) {
        //     return json.rows;
        //   } else {
        //     return null;
        //   }
        // })
        .toPromise()
        .then((json: any) => {
          if (json && json.rows) {
            return json.rows;
          } else {
            return null;
          }
        })
    );
  }
}
